import { extendTheme } from '@chakra-ui/react';
import {
  ASSET_COLOR,
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

const theme = {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '50px',
    subHeading: '14px',
    body: '14px',
  },
  textStyles: { // Responsive object
    heading: { fontSize: { base: '40px', xs: '42px', xp: '48px', md: '56px' } },
    subHeading: { fontSize: { base: '14px', xs: '14px', md: '14px' } },
    body: { fontSize: { base: '14px', xs: '14px', md: '14px' } },
  },

  fontWeights: {
    heading: 400,
    subHeading: 700,
    body: 700,
  },
  breakpoints: {
    base: '0em', // 0px
    xs: '360px', // Galaxy S8
    xp: '390px', // Iphone Pro
    xr: '410px', // Iphone XR
    sm: '480px',
    md: '500px',
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    backgroundAssetColor: BG_LAYER,
    mainAssetColor: ASSET_COLOR,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
  },
};

export default extendTheme(theme);
